/* eslint-disable import/no-anonymous-default-export */
import {
    ADD_CRITERIA,
    ADD_CRITERIA_ERROR,
    GET_ALL_CRITERIA,
    ALL_CRITERIA_ERROR,
    DELETE_CRITERIA,
    DELETE_CRITERIA_ERROR,
    SELECT_CRITERIA,
    GET_CRITERIA_PAGINATED,
    CRITERIA_PAGINATED_ERROR,
    GET_CRITERIA_COUNT,
    GET_CRITERIA_COUNT_ERROR,
    SET_CRITERIA_IS_LOADING_TRUE,
    GET_SEARCH_CRITERIA_PAGINATED,
    GET_SEARCH_CRITERIA_PAGINATED_ERROR,
    GET_SEARCH_CRITERIA_COUNT,
    GET_SEARCH_CRITERIA_COUNT_ERROR,
} from "../actions/types";

const initialState = {
    criteria: [],
    isLoading: true,
    success: false,


    // USED IN NEW STAND ALONE CMS 
    isLoadingCriteriaList: true,
    criteriaPaginated: [],
    criteriaCount: null,
    searchCriteriaPaginated: [],
    searchCriteriaCount: null,
    selectedCriteria: null,
};

export default function (state = initialState, action) {
    const { payload, type } = action;

    switch (type) {
        case SET_CRITERIA_IS_LOADING_TRUE:
            return {
                ...state,
                isLoadingCriteriaList: true,
                success: true,
            };
        case GET_CRITERIA_PAGINATED:
            return {
                ...state,
                criteriaPaginated: payload,
                isLoadingCriteriaList: false,
                success: true,
            };
        case CRITERIA_PAGINATED_ERROR:
            return {
                ...state,
                criteriaPaginated: payload,
                isLoadingCriteriaList: false,
                success: false,
            };
        case GET_CRITERIA_COUNT:
            return {
                ...state,
                criteriaCount: payload,
                isLoading: false,
                success: true,
            };
        case GET_CRITERIA_COUNT_ERROR:
            return {
                ...state,
                criteriaCount: payload,
                isLoading: false,
                success: false,
            };
        case GET_SEARCH_CRITERIA_PAGINATED:
            return {
                ...state,
                searchCriteriaPaginated: payload,
                isLoadingCriteriaList: false,
                success: true,
            };
        case GET_SEARCH_CRITERIA_PAGINATED_ERROR:
            return {
                ...state,
                searchCriteriaPaginated: payload,
                isLoadingCriteriaList: false,
                success: false,
            };
        case GET_SEARCH_CRITERIA_COUNT:
            return {
                ...state,
                searchCriteriaCount: payload,
                isLoading: false,
                success: true,
            };
        case GET_SEARCH_CRITERIA_COUNT_ERROR:
            return {
                ...state,
                searchCriteriaCount: payload,
                isLoading: false,
                success: false,
            };







        case GET_ALL_CRITERIA:
            return {
                ...state,
                criteria: payload,
                isLoading: false,
                success: true,
            };
        case ADD_CRITERIA:
        case DELETE_CRITERIA:
            return {
                ...state,
                isLoading: false,
                success: true,
            };
        
        case SELECT_CRITERIA:
            return {
                ...state,
                selectedCriteria: payload,
            };
        case ALL_CRITERIA_ERROR:
            return {
                ...state,
                criteria: payload,
                isLoading: false,
                success: false,
            };
        
        case ADD_CRITERIA_ERROR:
        case DELETE_CRITERIA_ERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
            };
        default:
            return state;
    }
}
